<template>
	<swiper :watch-slides-progress="true" :slides-per-view="5" :centered-slides="true" :loop="true"
		:looped-slides="slides.length + 5" :loop-additional-slides="2" :modules="modules" :autoplay="autoplayOptions"
		:watch-slides-visibility="true" @progress="onProgress" @set-transition="onSetTransition" @swiper="onSwiper"
		@slide-change="onSlideChange">
		<swiper-slide v-for="(slide, index) in slides" :key="index" @click="handleSlideClick(index)">
			<img :src="slide.image" />
		</swiper-slide>
	</swiper>
</template>
<script setup>
	import {
		ref
	} from 'vue'
	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue'
	import {
		Pagination,
		Autoplay
	} from 'swiper/modules';
	import 'swiper/css'
	import 'swiper/css/autoplay'
	import './style.css';

	const modules = [Pagination, Autoplay]
	const swiperInstance = ref(null);
	const onSwiper = (swiper) => {
		swiperInstance.value = swiper
		// 初始化后强制更新循环
	}
	// 自动轮播配置
	const autoplayOptions = ref({
		delay: 3000, // 3秒切换一次
		pauseOnMouseEnter: true, // 鼠标悬停时暂停
	})

	const slides = ref([
		// {
		// 	image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/rabbit/0.jpg',
		// },
		{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%81%AB%E9%94%85%E6%88%AA%E5%9B%BE/5324adc4-a5af-418e-92d1-25b9602c110e.png',
		},
		{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%81%AB%E9%94%85%E6%88%AA%E5%9B%BE/edc3e414-c675-486e-8772-2ef2ac2566bc.png',
		},
		{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%81%AB%E9%94%85%E6%88%AA%E5%9B%BE/d6da97ea-8834-4462-b484-800bc34bc0a0.png',
		},
		{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%81%AB%E9%94%85%E6%88%AA%E5%9B%BE/4e39f7c6-0884-467d-958c-15fc1d6ddffb.png',
		},
		{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%81%AB%E9%94%85%E6%88%AA%E5%9B%BE/6e708c55-6386-4e33-ba32-3eccb40859c9.png',
		},
		{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%81%AB%E9%94%85%E6%88%AA%E5%9B%BE/59e8c675-4786-43d1-96d8-cf011aef778a.png',
		},
		{
			image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E7%81%AB%E9%94%85%E6%88%AA%E5%9B%BE/468759ab-5a13-456d-ba78-2159d81570aa.png',
		}
	])

	const onProgress = (swiper, progress) => {
		for (let i = 0; i < swiper.slides.length; i++) {
			const slideEl = swiper.slides[i]
			const slideProgress = swiper.slides[i].progress
			let modify = 1

			if (Math.abs(slideProgress) > 1) {
				modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
			}

			const translate = slideProgress * modify * 160 + 'px'
			const scale = 1 - Math.abs(slideProgress) / 5
			const zIndex = 999 - Math.abs(Math.round(10 * slideProgress))

			slideEl.style.transform = `translateX(${translate}) scale(${scale})`
			slideEl.style.zIndex = zIndex
			slideEl.style.opacity = 1

			if (Math.abs(slideProgress) > 3) {
				slideEl.style.opacity = 0
			}
		}
	}
	// 修改onSlideChange方法
	const onSlideChange = (swiper) => {
	}
	const onSetTransition = (swiper, transition) => {
		for (let i = 0; i < swiper.slides.length; i++) {
			const slideEl = swiper.slides[i]
			slideEl.style.transition = `${transition}ms`
		}
	}
	const handleSlideClick = (index) => {
		if (swiperInstance.value) {
			swiperInstance.value.slideToLoop(index, 500);
		}
	};
</script>

<style scoped>
	.swiper {
		margin-top: 150px;
		margin-bottom: 100px;
		transform: scale(1.7);
	}

	.swiper-slide {
		background-position: center;
		background-size: cover;

		width: 520px;
		height: 208px;
		background: #fff;
		box-shadow: 0 8px 30px #ddd;
	}

	.swiper-slide img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.swiper-slide p {
		line-height: 98px;
		padding-top: 0;
		text-align: center;
		color: #636363;
		font-size: 1.1em;
		margin: 0;
	}
</style>